export default __webpack_public_path__ + "static/media/no-products.9f6852c0.png";